import { sortBy } from 'underscore';
import { CriterionPreviewParameterKeys, CriterionTypes, TRAFFIC_SOURCE_PREVIEW_PARMS_KEY, AdSourcePreviewParamsByGranularity } from 'smart-content-core/constants';

const findSmartRuleById = (smartRules, smartRuleId) => {
  return smartRules.find(smartRule => smartRule.criterion_id === smartRuleId);
};

export const updateSmartRuleContent = (smartRules, smartId, content) => {
  const newSmartRules = [...smartRules];
  const smartRuleIndex = newSmartRules.findIndex(smartContent => smartContent.criterion_id === smartId);

  if (smartRuleIndex > -1) {
    const smartRule = newSmartRules[smartRuleIndex];
    newSmartRules[smartRuleIndex] = Object.assign({}, smartRule, {}, content);
    return newSmartRules;
  }

  return smartRules;
};
export const updateSmartRules = (currentSmartRules = [], updatedSmartRules) => {
  const sortedUpdatedSmartRules = sortBy(updatedSmartRules, smartRule => smartRule.order);
  return sortedUpdatedSmartRules.reduce((newSmartRules, smartRule) => {
    const {
      criterion_id: smartRuleId,
      order: newOrder
    } = smartRule;
    const existingSmartRule = findSmartRuleById(currentSmartRules, smartRuleId);

    if (existingSmartRule && existingSmartRule.order !== newOrder) {
      existingSmartRule.order = newOrder;
    }

    newSmartRules.push(existingSmartRule || smartRule);
    return newSmartRules;
  }, []);
};
export const getSmartRulePreviewparams = smartRule => {
  const smartRuleParams = {};
  const {
    smartType,
    value
  } = smartRule;

  switch (smartType) {
    case CriterionTypes.QUERY_PARAM:
      {
        const {
          query
        } = smartRule;
        if (query) smartRuleParams[query.name] = query.value;
        return smartRuleParams;
      }

    case CriterionTypes.TRAFFIC_SOURCE:
      {
        const previewKey = CriterionPreviewParameterKeys[smartType];
        const {
          drillDownRule,
          visitSource
        } = smartRule;

        if (drillDownRule && visitSource) {
          smartRuleParams[previewKey] = visitSource;
          smartRuleParams[TRAFFIC_SOURCE_PREVIEW_PARMS_KEY] = drillDownRule;
        } else {
          smartRuleParams[previewKey] = value;
        }

        return smartRuleParams;
      }

    case CriterionTypes.AD_SOURCE:
      {
        const {
          granularity
        } = smartRule;

        if (granularity) {
          const adSourceGranularity = AdSourcePreviewParamsByGranularity[granularity];
          smartRuleParams[adSourceGranularity] = value;
        }

        return smartRuleParams;
      }

    default:
      {
        const previewKey = CriterionPreviewParameterKeys[smartType];
        smartRuleParams[previewKey] = value;
        return smartRuleParams;
      }
  }
};